import type { GetUserStatusContentFunction } from './UserFallback.types'

export const getUserStatusContent: GetUserStatusContentFunction =
    userStatus => {
        switch (userStatus) {
            case 'passive':
                return {
                    title: '@user.UserFallback.passive_title',
                    description: '@user.UserFallback.passive_description',
                }
            case 'blacklisted':
                return {
                    title: '@user.UserFallback.blacklisted_title',
                    description: '@user.UserFallback.blacklisted_description',
                }
            default:
                return {
                    title: '@user.UserFallback.passive_title',
                    description: '@user.UserFallback.passive_description',
                }
        }
    }
